import {
  TablePage,
  AddPage,
  EditPage,
  ViewPage,
} from 'src/views/partyconfig'
import pathMap from 'src/paths/pathMap'

class PartyConfigRoute {
  getConfigurations() {
    return [
      {
        exact: true,
        path: pathMap.PARTY_CONFIG_LIST_VIEW,
        component: TablePage
      },
      {
        exact: true,
        path: pathMap.PARTY_CONFIG_ADD_VIEW,
        component: AddPage
      },
      {
        exact: true,
        path: pathMap.PARTY_CONFIG_EDIT_VIEW,
        component: EditPage
      },
      {
        exact: true,
        path: pathMap.PARTY_CONFIG_DETAILS_VIEW,
        component: ViewPage
      }
    ]
  }
}

export default PartyConfigRoute
